import { SpecialTreatment } from "../tools/filter";

const mutations = {
  CHANGE_USER_INFO(state, val) {
    if (val) {
      state.user = val;
      localStorage.setItem("user", JSON.stringify(val));
    } else {
      state.user = {};
      localStorage.removeItem("user");
    }
  },
  SAVE_WC(state, data) {
    state.wc = data;
  },
  SAVE_WS(state, data) {
    state.ws = data;
  },
  SET_TRADING_PRICE(state, opt) {
    state.tradingPrice = SpecialTreatment.setDecimalPlaces(
      opt.val,
      opt.decimals
    );
  },
  GET_DATA_BASE_USER(state) {
    let data = localStorage.getItem("user");
    data = JSON.parse(data);
    if (data) {
      state.user = data;
      localStorage.setItem("user", JSON.stringify(data));
    } else {
      state.user = {};
      localStorage.removeItem("user");
    }
  },
  SET_CHAIN_SYSTEM_INNFO(state, opt) {
    state.chainSystemInfo = opt;
  },
  SET_FEE_CONFIGS_INFO(state, opt) {
    state.feeConfigsInfo = opt;
  },
  SET_BOX_TRADING_PAIT_SHOW(state, opt) {
    state.boxTradingPairShow = opt;
  },
};

export default mutations;
